(function() { window.GUID_e1211599_f81c_4142_a656_0560056240db = { getGuid: function() { return "e1211599-f81c-4142-a656-0560056240db"; } }; })();
//alert('test'); 

//# sourceMappingURL=test.js.map
